import ReadyRequestDisplayData from "./ReadyRequestDisplayData";
import RequestDeleteToolState from "./RequestDeleteToolState";
const Controller = {
  ReadyRequestDisplayData,
  RequestDeleteToolState
};

export default Controller;
